import React, { useState, useEffect } from "react";
import withAuth from "./../../common/helper/auth-component.js";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import DashboardService from "../../../services/dashboard-service.js";
import LoaderOverlay from "./../../common/helper/loader.component.js";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FundsService from "../../../services/funds-service.js";
import PaymentMethodsService from "../../../services/payment-methods.service.js";
import StatusBadge from "../../common/helper/transaction-status.component.js";
import RadialBarChart from "../../common/charts/radial-bar-chart.jsx";
import BarChart from "../../common/charts/row-bar-chart.jsx";
import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import moment from "moment";
import StorefrontIcon from "@mui/icons-material/Storefront";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import MuseumOutlinedIcon from "@mui/icons-material/MuseumOutlined";
import MultiSeriesBarChart from "../../common/charts/column-bar-chart.jsx";
import MultiColumnBarChart from "../../common/charts/multi-series-column-bar.jsx";
import { PieChart } from "@mui/icons-material";
import PieChartExample from "../../common/charts/pie-chart.jsx";
import AreaChart from "../../common/charts/area-chart.jsx";
import PremiumTopAuthors from "../../common/miui-component/top-list-card2.jsx";
import EnhancedTopAuthors from "../../common/miui-component/top-list-card.jsx";
import TransactionHistory from "../../common/miui-component/top-list-card4.jsx";
import TopTransactionHistory from "../../common/miui-component/top-list-card5.jsx";
import { payInData } from "../../../constants/dummyData.js";
import PendingIcon from "@mui/icons-material/Pending";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SmsFailedIcon from "@mui/icons-material/SmsFailed";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import { Switch } from "@mui/material";
import SuccessRate from "../../common/miui-component/sucessRate.jsx";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state.authReducer.user.data);
  const [transaction, setTransactionData] = useState();
  const [fundHistory, setFundHistory] = useState([]);
  const [transactionCount, setTransactionCount] = useState({});
  const [topPerformers, setTopPerfomers] = useState([]);
  const [transactionList, setTransactionList] = useState([]);
  const [paymentMethodsData, setPaymentMethodsData] = useState({});
  const [system, setSystem] = useState({});
  const [percentage, setMaxPercentage] = useState({ percentage: "", type: "" });
  const [payInDuration, setPayInDuration] = useState("Today");
  const [payoutDuration, setPayOutDuration] = useState("Today");
  const [ticketing, setTicketing] = useState([]);
  const [ticketingDuration, setTicketingDuration] = useState("Today");
  const [srDuration, setSRDuration] = useState("1hr");

  const [overAllDetails, setOverAllDetails] = useState([]);
  const [successDetails, setSuccessDetails] = useState([]);
  const [actorsDetails, setActorsDetails] = useState([]);
  const [topTickets, setTopTicketing] = useState([]);
  const [isAgent, setIsAgent] = useState(false);
  const [isPayout, setIsPayout] = useState(false);
  const [statusSummary, setStatusSummary] = useState({
    payin: [
      { status: "Orders", count: "0", percetage: "0%" },
      { status: "Sucess", count: "0", percetage: "0%" },
      { status: "Pending", count: "0", percetage: "0%" },
      { status: "Initiated", count: "0", percetage: "0%" },
      { status: "Failed", count: "0", percetage: "0%" },
      { status: "Expired", count: "0", percetage: "0%" },
    ],
  });
  const [statusSummaryPayout, setStatusSummaryPayout] = useState({
    payout: [
      { status: "Orders", count: "0", percetage: "0%" },
      { status: "Sucess", count: "0", percetage: "0%" },
      { status: "Pending", count: "0", percetage: "0%" },
      { status: "Initiated", count: "0", percetage: "0%" },
      { status: "Failed", count: "0", percetage: "0%" },
      { status: "Expired", count: "0", percetage: "0%" },
    ],
  });

  const fetchData = async () => {
    try {
      setLoading(true);
      const [
        transactionSummary,
        transactionList,
        paymentMethods,
        fundsHistory,
        count,
        sysAnlysis,
        topPerformers,
        ticketing,
        overAllDetails,
        actorsStatsData,
        topTicketing,
        successDetails,
      ] = await Promise.all([
        DashboardService.getTransactions(),
        DashboardService.getTransactionsList({}, 0, 10),
        PaymentMethodsService.getAdminPaymentMethods(),
        FundsService.fundHistory({}, 0, 10),
        DashboardService.getCount(),
        DashboardService.getSystemAnalysis(),
        DashboardService.getTopPerformers(),
        DashboardService.getTicketingStats(),
        DashboardService.getOverAllDetails(),
        DashboardService.getActorsStats(),
        DashboardService.getTopTicketing(),
        DashboardService.getSuccessDetails(1),
      ]);
      console.log(actorsStatsData);
      setTransactionData(transactionSummary.data.data);
      setTransactionList(transactionList.data.data.list);
      setFundHistory(fundsHistory.data.data.list);
      setTransactionCount(count.data.data);
      setSystem(sysAnlysis.data.data);
      setTicketing(ticketing.data.data);
      setTopPerfomers(topPerformers.data.data);
      setTopTicketing(topTicketing.data.data);
      setOverAllDetails(overAllDetails.data.data);
      setSuccessDetails(successDetails.data.data);
      setActorsDetails(actorsStatsData.data.data);
      const { maxAmount, maxAmountKey } = getMaxAmount(count.data.data);
      const keyDescription = getKeyDescription(maxAmountKey);
      setMaxPercentage({
        percentage: maxAmount,
        type: keyDescription,
      });
      let finalData = {};
      let paymentResponse = paymentMethods.data.data;

      for (var i = 0; i < paymentResponse.length; i++) {
        if (paymentResponse[i].code == "WLT") {
          finalData["walletStatus"] = paymentResponse[i].status_id;
        }
        if (paymentResponse[i].code == "UPI") {
          finalData["upiStatus"] = paymentResponse[i].status_id;
        }
        if (paymentResponse[i].code == "QR") {
          finalData["qrStatus"] = paymentResponse[i].status_id;
        }
      }
      if (paymentResponse && paymentResponse.length == 0) {
        console.log("dsadsa");
        finalData["walletStatus"] = "S";
        finalData["upiStatus"] = "S";
        finalData["qrStatus"] = "S";
      }

      setPaymentMethodsData(finalData);
      setLoading(false);
    } catch (error) {
      console.log(error);
      try {
        const errorMessage = error.response.data;
        toast.error(errorMessage.error.message || "Internal Server Error");
      } catch (e) {
        toast.error("Internal Server Error");
      }
      setLoading(false);
    }
  };

  const getKeyDescription = (key) => {
    // Return corresponding description based on key
    switch (key) {
      case "wallet_count":
        return "Wallet";
      case "qr_count":
        return "QR Code";
      case "upi_count":
        return "UPI";
      default:
        return "";
    }
  };
  const getMaxAmount = (data) => {
    let maxAmount = 0;
    let maxAmountKey = "";

    // Calculate total count
    const totalCount = Object.values(data).reduce((acc, curr) => acc + curr, 0);

    // Iterate through the data object to find the key with the maximum amount
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const percentage = Math.round((data[key] * 100) / totalCount);
        if (percentage > maxAmount) {
          maxAmount = percentage;
          maxAmountKey = key;
        }
      }
    }

    return { maxAmount, maxAmountKey };
  };

  const durationForPayIn = (duration) => {
    setPayInDuration(duration);
  };
  const durationForPayOut = (duration) => {
    setPayOutDuration(duration);
  };
  const durationForTicketing = (duration) => {
    setTicketingDuration(duration);
  };
  const durationForSR = (duration) => {
    setLoading(true);
    DashboardService.getSuccessDetails(duration)
      .then((response) => {
        setLoading(false);
        setSuccessDetails(response.data.data);
      })
      .catch((error) => {
        setLoading(false);
      });
    setSRDuration(duration);
  };

  const viewProfile = () => {
    navigate(`/view-user/${userData.user_id}`);
  };

  const viewTransaction = (row) => {
    navigate(`/transaction/${row.transaction_id}`);
  };
  const viewTransactions = (row) => {
    navigate(`/transactions`);
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short" };
    return date.toLocaleDateString("en-US", options);
  };
  const viewPaymentMethods = () => {
    navigate(`/admin-payments`);
  };
  const fundListing = () => {
    navigate(`/funds-listing`);
  };

  useEffect(() => {
    document.body.style.backgroundImage = "";
    fetchData();
    document.body.style.backgroundColor = "#f0f6fa";
    return () => {
      document.body.style.backgroundColor = ""; // Reset body color when ComponentOne unmounts
    };
  }, []);

  const walletPercentage = Math.round(
    (transactionCount.wallet_count * 100) /
      Object.values(transactionCount).reduce((acc, curr) => acc + curr, 0)
  );
  const qrPercentage = Math.round(
    (transactionCount.qr_count * 100) /
      Object.values(transactionCount).reduce((acc, curr) => acc + curr, 0)
  );
  const upiPercentage = Math.round(
    (transactionCount.upi_count * 100) /
      Object.values(transactionCount).reduce((acc, curr) => acc + curr, 0)
  );
  let sumAlltransaction =
    transactionCount.wallet_count +
    transactionCount.upi_count +
    transactionCount.qr_count;
  const radialChartDataSet = {
    labelName: ["Wallet", "UPI", "QR Code"],
    colors: ["#a3d1d5d9", "#A6BED2A3", "#495A69"],
    sumAlltransaction: sumAlltransaction,
    series: [
      ((transactionCount.wallet_count / sumAlltransaction) * 100).toFixed(2),
      ((transactionCount.upi_count / sumAlltransaction) * 100).toFixed(2),
      ((transactionCount.qr_count / sumAlltransaction) * 100).toFixed(2),
    ],
  };
  const handleStatusSummary = (summary) => {
    console.log(summary);
    setStatusSummary(summary);
  };
  const handleStatusSummaryPayout = (summary) => {
    console.log(summary);
    setStatusSummaryPayout(summary);
  };

  return (
    <>
      {" "}
      <LoaderOverlay loading={loading} />
      <div
        className="container-fluid px-3 px-md-5 "
        style={{ paddingBottom: "30px" }}
      >
        <h4
          className="mb-3 updatename updatename1 align-self-center text-color-theme"
          style={{ marginTop: 0, fontWeight: 700, fontSize: "22px" }}
        >
          Dashboard
        </h4>
        <div>
          <div className>
            <div className="row">
              <div>
                <div className="row">
                  <div className="col-sm-12 col-md-12 pb-4">
                    <div className="col-12" style={{ height: "100%" }}>
                      <div
                        className="bg-light  py-1 py-md-3 mb-3 d-flex flex flex-column justify-content-center overview-block"
                        style={{ borderRadius: "18px", height: "100%" }}
                      >
                        <h3 className="mb-0 pt-2 ps-3 fs-5">Overview</h3>
                        <div className="d-flex flex-sm-row overview-details">
                          <div className="flex-fill m-0 p-0">
                            <div
                              className="card mini-stats-wid "
                              style={{
                                borderWidth: "0px",
                                marginBottom: "0px",
                              }}
                            >
                              <div className="card-body rounded py-3 py-md-5">
                                <div className="d-flex">
                                  <div className="flex-shrink-0 align-self-center">
                                    <div
                                      className="border-round-30  mini-stat-icon"
                                      style={{ width: "50px", height: "50px" }}
                                    >
                                      <span
                                        className="avatar-title"
                                        style={{ backgroundColor: "#495A69" }}
                                      >
                                        {/* <i
                                  className="fa fa-users font-size-19"
                                  style={{ color: "white" }}
                                  /> */}
                                        <MuseumOutlinedIcon
                                          sx={{ color: "white" }}
                                        />
                                      </span>
                                    </div>
                                  </div>
                                  <div className="flex-grow-1">
                                    <p className="ms-3 fw-medium fs-7 mb-0 light-gray-label-text">
                                      Merchants
                                    </p>
                                    <div className="d-flex justify-content-start align-items-center">
                                      <h4 className="mb-0 ms-3 fs-5 mb-0 fs-2 mt-0">
                                        {actorsDetails?.merchant?.total_count}
                                      </h4>{" "}
                                      <span
                                        className="ms-1"
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          color: "green",
                                        }}
                                      >
                                        {" "}
                                        Active -{" "}
                                        {actorsDetails?.merchant
                                          ?.active_count || 0}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex-fill m-0 p-0">
                            <div
                              className="card mini-stats-wid "
                              style={{
                                borderWidth: "0px",
                                marginBottom: "0px",
                              }}
                            >
                              <div className="card-body rounded py-3 py-md-5">
                                <div className="d-flex">
                                  <div className="flex-shrink-0 align-self-center">
                                    <div
                                      className="border-round-30  mini-stat-icon"
                                      style={{ width: "50px", height: "50px" }}
                                    >
                                      <span
                                        className="avatar-title"
                                        style={{ backgroundColor: "#495A69" }}
                                      >
                                        <StorefrontIcon
                                          sx={{ color: "white" }}
                                        />
                                      </span>
                                    </div>
                                  </div>
                                  <div className="flex-grow-1">
                                    <p className="ms-3 fw-medium fs-7 mb-0 light-gray-label-text">
                                      Distributor
                                    </p>
                                    <div className="d-flex justify-content-start align-items-center">
                                      <h4 className="mb-0 ms-3 fs-5 mb-0 fs-2 mt-0 ">
                                        {actorsDetails?.distributor
                                          ?.total_count || 0}
                                      </h4>{" "}
                                      <span
                                        className="ms-1"
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          color: "green",
                                        }}
                                      >
                                        {" "}
                                        Active -{" "}
                                        {actorsDetails?.distributor
                                          ?.active_count || 0}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex-fill m-0 p-0">
                            <div
                              className="card mini-stats-wid "
                              style={{
                                borderWidth: "0px",
                                marginBottom: "0px",
                              }}
                            >
                              <div className="card-body rounded py-3 py-md-5">
                                <div className="d-flex">
                                  <div className="flex-shrink-0 align-self-center ">
                                    <div
                                      className="border-round-30  mini-stat-icon"
                                      style={{ width: "50px", height: "50px" }}
                                    >
                                      <span
                                        className="avatar-title"
                                        style={{ backgroundColor: "#495A69" }}
                                      >
                                        <PeopleAltOutlinedIcon
                                          sx={{ color: "white" }}
                                        />
                                      </span>
                                    </div>
                                  </div>
                                  <div className="flex-grow-1">
                                    <p className="ms-3 fs-7 fw-medium mb-0 light-gray-label-text">
                                      Agents
                                    </p>
                                    <div className="d-flex justify-content-start align-items-end">
                                      <h4 className="mb-0 ms-3 fs-5 mb-0 fs-2 mt-0 ">
                                        {actorsDetails?.system_agents
                                          ?.total_count || 0}
                                      </h4>{" "}
                                      <span
                                        className="ms-1"
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          color: "green",
                                        }}
                                      >
                                        {" "}
                                        Active -{" "}
                                        {actorsDetails?.system_agents
                                          ?.active_count || 0}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex-fill m-0 p-0">
                            <div
                              className="card mini-stats-wid "
                              style={{
                                borderWidth: "0px",
                                marginBottom: "0px",
                              }}
                            >
                              <div className="card-body rounded py-3 py-md-5">
                                <div className="d-flex">
                                  <div className="flex-shrink-0 align-self-center ">
                                    <div
                                      className="border-round-30  mini-stat-icon"
                                      style={{ width: "50px", height: "50px" }}
                                    >
                                      <span
                                        className="avatar-title"
                                        style={{ backgroundColor: "#495A69" }}
                                      >
                                        <i className="bx bx-user font-size-24" />
                                      </span>
                                    </div>
                                  </div>
                                  <div className="flex-grow-1">
                                    <p className="ms-3 fs-7 fw-medium mb-0 light-gray-label-text">
                                      D~Agents
                                    </p>
                                    <div className="d-flex justify-content-start align-items-center">
                                      <h4 className="mb-0 ms-3 fs-2 mt-0 mb-0">
                                        {actorsDetails?.distributor_agents
                                          ?.total_count || 0}
                                      </h4>{" "}
                                      <span
                                        className="ms-1"
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          color: "green",
                                        }}
                                      >
                                        {" "}
                                        Active -{" "}
                                        {actorsDetails?.distributor_agents
                                          ?.active_count || 0}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex-fill m-0 p-0">
                            <div
                              className="card mini-stats-wid "
                              style={{
                                borderWidth: "0px",
                                marginBottom: "0px",
                              }}
                            >
                              <div className="card-body rounded py-3 py-md-5">
                                <div className="d-flex">
                                  <div className="flex-shrink-0 align-self-center ">
                                    <div
                                      className="border-round-30  mini-stat-icon"
                                      style={{ width: "50px", height: "50px" }}
                                    >
                                      <span
                                        className="avatar-title"
                                        style={{ backgroundColor: "#495A69" }}
                                      >
                                        <CardGiftcardIcon
                                          sx={{ color: "white" }}
                                        />
                                      </span>
                                    </div>
                                  </div>
                                  <div className="flex-grow-1">
                                    <p className="ms-3 fs-7 fw-medium mb-0 light-gray-label-text">
                                      Pending Payouts
                                    </p>
                                    <div className="d-flex justify-content-start align-items-end">
                                      <h4 className="mb-0 ms-3 fs-5 mb-0 fs-2 mt-0 ">
                                        {actorsDetails?.payouts_due
                                          ?.total_count || 0}
                                      </h4>
                                      <span
                                        className="ms-1"
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          color: "green",
                                        }}
                                      >
                                        {" "}
                                        ₹
                                        {actorsDetails?.payouts_due
                                          ?.total_amount
                                          ? actorsDetails?.payouts_due?.total_amount
                                              .toString()
                                              .includes(".")
                                            ? actorsDetails?.payouts_due?.total_amount
                                                .toString()
                                                .split(".")[0]
                                            : actorsDetails?.payouts_due
                                                ?.total_amount
                                          : 0}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="flex-fill m-0 p-0">
                            <div
                              className="card mini-stats-wid "
                              style={{
                                borderWidth: "0px",
                                marginBottom: "0px",
                              }}
                            >
                              <div className="card-body rounded py-3 py-md-5">
                                <div className="d-flex">
                                  <div className="flex-shrink-0 align-self-center ">
                                    <div
                                      className="border-round-30  mini-stat-icon"
                                      style={{ width: "50px", height: "50px" }}
                                    >
                                      <span
                                        className="avatar-title"
                                        style={{ backgroundColor: "#495A69" }}
                                      >
                                        <LocalActivityIcon
                                          sx={{ color: "white" }}
                                        />
                                      </span>
                                    </div>
                                  </div>
                                  <div className="flex-grow-1">
                                    <p className="ms-3 fs-7 fw-medium mb-0 light-gray-label-text">
                                      Tickets
                                    </p>
                                    <div className="d-flex justify-content-start align-items-center">
                                      <h4 className="mb-0 ms-3 fs-2 mt-0 mb-0">
                                        {actorsDetails?.tickets?.total_count ||
                                          0}
                                      </h4>
                                      <span
                                        className="ms-1"
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          color: "green",
                                        }}
                                      >
                                        Pending -{" "}
                                        {actorsDetails?.tickets
                                          ?.pending_count || 0}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12"></div>
                  </div>
                </div>

                {/* Pay In Payu out graph */}

                <div className="row">
                  <div className="col-xl-6">
                    <div className="card shadow-sm card-layout">
                      <div
                        className="card-header bg-transparent"
                        style={{ padding: "21px" }}
                      >
                        <div className="d-flex flex-wrap align-items-start turnover">
                          <div
                            className="me-2 align-self-center"
                            style={{ height: "100%" }}
                          >
                            <h5 className="card-title fs-5 mt-1 mb-0 ">
                              Pay In
                            </h5>
                          </div>
                          <ul
                            className="nav nav-tabs nav-tabs-turnover nav-tabs-custom card-header-tabs ms-auto"
                            role="tablist"
                            style={{
                              borderBottom: "0px solid var(--bs-border-color)",
                            }}
                          >
                            <li
                              className="nav-item"
                              role="presentation"
                              onClick={() => durationForPayIn("Today")}
                            >
                              <a
                                className="nav-link active px-2"
                                style={{
                                  fontSize: "12px",
                                }}
                                data-bs-toggle="tab"
                                href="#post-recent"
                                role="tab"
                                aria-selected="true"
                              >
                                {" "}
                                Today{" "}
                              </a>
                            </li>
                            <li
                              className="nav-item"
                              role="presentation"
                              onClick={() => durationForPayIn("Yesterday")}
                            >
                              <a
                                className="nav-link px-2"
                                style={{
                                  fontSize: "12px",
                                }}
                                data-bs-toggle="tab"
                                href="#post-recents"
                                role="tab"
                                aria-selected="false"
                                tabIndex={-1}
                              >
                                Yesterday{" "}
                              </a>
                            </li>
                            <li
                              className="nav-item"
                              role="presentation"
                              onClick={() => durationForPayIn("Weekly")}
                            >
                              <a
                                className="nav-link px-2"
                                style={{
                                  fontSize: "12px",
                                }}
                                data-bs-toggle="tab"
                                href="#post-popular"
                                role="tab"
                                aria-selected="false"
                                tabIndex={-1}
                              >
                                {" "}
                                Weekly{" "}
                              </a>
                            </li>
                            <li
                              className="nav-item"
                              role="presentation"
                              onClick={() => durationForPayIn("Monthly")}
                            >
                              <a
                                className="nav-link px-2"
                                style={{
                                  fontSize: "12px",
                                }}
                                data-bs-toggle="tab"
                                href="#post-populars"
                                role="tab"
                                aria-selected="false"
                                tabIndex={-1}
                              >
                                {" "}
                                Monthly{" "}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="card-body">
                        {/* <h4 className="card-title mb-4 fs-5">
                          Payment Analytics
                        </h4> */}
                        <div
                          style={{
                            backgroundColor: "#ffffff",
                            borderRadius: "10px",
                          }}
                        >
                          <div>
                            <MultiColumnBarChart
                              payInDuration={payInDuration}
                              type="PayIn"
                              sendStatusSummary={handleStatusSummary}
                            />
                          </div>
                          <div className="flex d-flex flex-wrap justify-content-around">
                            {statusSummary?.payin?.map((item, index) => {
                              return (
                                <div
                                  className={`d-flex  flex-column flex-md-row  p-3 border w-[32.90%] justify-content-between ${
                                    index == 1 || index == 2
                                  }`}
                                  style={{
                                    marginBottom: "2px",
                                    background: "rgb(206 234 236 / 55%)",
                                    borderTopLeftRadius:
                                      index == 0 ? "10px" : "0px",
                                    borderTopRightRadius:
                                      index == 2 ? "10px" : "0px",
                                    borderBottomLeftRadius:
                                      index == 3 ? "10px" : "0px",
                                    borderBottomRightRadius:
                                      index == 5 ? "10px" : "0px",
                                  }}
                                >
                                  <div
                                    className={`flex d-flex justify-content-around gap-2`}
                                  >
                                    <div
                                      style={{ alignSelf: "center" }}
                                      className="payincountimage"
                                    >
                                      {index === 0 && (
                                        <PendingIcon
                                          sx={{ fontSize: "33px" }}
                                        />
                                      )}
                                      {index === 1 && (
                                        <ShoppingBagIcon
                                          sx={{ fontSize: "33px" }}
                                        />
                                      )}
                                      {index === 2 && (
                                        <CheckCircleIcon
                                          sx={{ fontSize: "33px" }}
                                        />
                                      )}

                                      {index === 4 && (
                                        <SmsFailedIcon
                                          sx={{ fontSize: "33px" }}
                                        />
                                      )}
                                      {index === 3 && (
                                        <AllInclusiveIcon
                                          sx={{ fontSize: "33px" }}
                                        />
                                      )}
                                      {index === 5 && (
                                        <AutorenewIcon
                                          sx={{ fontSize: "33px" }}
                                        />
                                      )}
                                    </div>
                                    <div className="">
                                      <p
                                        style={{
                                          fontSize: "19px",
                                          fontWeight: "600",
                                          margin: 0,
                                        }}
                                      >
                                        {item.count}
                                      </p>
                                      <p
                                        style={{
                                          margin: 0,
                                        }}
                                      >
                                        {item.status}
                                      </p>
                                    </div>
                                  </div>

                                  <div style={{ alignSelf: "end" }}>
                                    <p
                                      style={{
                                        margin: 0,
                                      }}
                                    >
                                      {item.percentage}
                                    </p>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                        {/* <p className="mb-0" style={{ fontWeight: 700 }}>
                      *Last Today details
                    </p> */}
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6 ">
                    <div className="col-12">
                      <div className="card card-layout shadow-sm">
                        <div
                          className="card-header bg-transparent"
                          style={{ padding: "21px" }}
                        >
                          <div className="d-flex flex-wrap align-items-start turnover">
                            <div
                              className="me-2 align-self-center"
                              style={{ height: "100%" }}
                            >
                              <h5 className="card-title fs-5 mt-1 mb-0 ">
                                Pay Out
                              </h5>
                            </div>
                            <ul
                              className="nav nav-tabs nav-tabs-turnover nav-tabs-custom card-header-tabs ms-auto"
                              role="tablist"
                              style={{
                                borderBottom:
                                  "0px solid var(--bs-border-color)",
                              }}
                            >
                              <li
                                className="nav-item"
                                role="presentation"
                                onClick={() => durationForPayOut("Today")}
                              >
                                <a
                                  className="nav-link active px-2"
                                  style={{
                                    fontSize: "12px",
                                  }}
                                  data-bs-toggle="tab"
                                  href="#post-recent"
                                  role="tab"
                                  aria-selected="true"
                                >
                                  {" "}
                                  Today{" "}
                                </a>
                              </li>
                              <li
                                className="nav-item"
                                role="presentation"
                                onClick={() => durationForPayOut("Yesterday")}
                              >
                                <a
                                  className="nav-link px-2"
                                  style={{
                                    fontSize: "12px",
                                  }}
                                  data-bs-toggle="tab"
                                  href="#post-recents"
                                  role="tab"
                                  aria-selected="false"
                                  tabIndex={-1}
                                >
                                  Yesterday{" "}
                                </a>
                              </li>
                              <li
                                className="nav-item"
                                role="presentation"
                                onClick={() => durationForPayOut("Weekly")}
                              >
                                <a
                                  className="nav-link px-2"
                                  style={{
                                    fontSize: "12px",
                                  }}
                                  data-bs-toggle="tab"
                                  href="#post-popular"
                                  role="tab"
                                  aria-selected="false"
                                  tabIndex={-1}
                                >
                                  {" "}
                                  Weekly{" "}
                                </a>
                              </li>
                              <li
                                className="nav-item"
                                role="presentation"
                                onClick={() => durationForPayOut("Monthly")}
                              >
                                <a
                                  className="nav-link px-2"
                                  style={{
                                    fontSize: "12px",
                                  }}
                                  data-bs-toggle="tab"
                                  href="#post-populars"
                                  role="tab"
                                  aria-selected="false"
                                  tabIndex={-1}
                                >
                                  {" "}
                                  Monthly{" "}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="card-body">
                          <div
                            style={{
                              // padding: "31px 0px",
                              backgroundColor: "#ffffff",
                              borderRadius: "10px",
                            }}
                          >
                            {/* <BarChart /> */}
                            {/* <p>dsdsdsds</p> */}
                            <MultiColumnBarChart
                              payInDuration={payoutDuration}
                              type="PayOut"
                              sendStatusSummaryPayout={
                                handleStatusSummaryPayout
                              }
                            />
                            <div className="flex d-flex flex-wrap justify-content-around">
                              {statusSummaryPayout?.payout?.map(
                                (item, index) => {
                                  return (
                                    <div
                                      className={`d-flex  flex-column flex-md-row  px-2 px-md-3 py-3 border w-[32.90%] justify-content-between ${
                                        index == 1 || index == 2
                                      }`}
                                      style={{
                                        marginBottom: "2px",
                                        background: "rgb(206 234 236 / 55%)",
                                        borderTopLeftRadius:
                                          index == 0 ? "10px" : "0px",
                                        borderTopRightRadius:
                                          index == 2 ? "10px" : "0px",
                                        borderBottomLeftRadius:
                                          index == 3 ? "10px" : "0px",
                                        borderBottomRightRadius:
                                          index == 5 ? "10px" : "0px",
                                      }}
                                    >
                                      <div
                                        className={`flex d-flex justify-content-around gap-2 `}
                                      >
                                        <div style={{ alignSelf: "center" }}>
                                          {/* <StorefrontIcon
                                        sx={{ fontSize: "30px" }} */}
                                          {index === 0 && (
                                            <PendingIcon
                                              sx={{ fontSize: "33px" }}
                                            />
                                          )}
                                          {index === 1 && (
                                            <ShoppingBagIcon
                                              sx={{ fontSize: "33px" }}
                                            />
                                          )}
                                          {index === 2 && (
                                            <CheckCircleIcon
                                              sx={{ fontSize: "33px" }}
                                            />
                                          )}

                                          {index === 4 && (
                                            <SmsFailedIcon
                                              sx={{ fontSize: "33px" }}
                                            />
                                          )}
                                          {index === 3 && (
                                            <AllInclusiveIcon
                                              sx={{ fontSize: "33px" }}
                                            />
                                          )}
                                          {index === 5 && (
                                            <AutorenewIcon
                                              sx={{ fontSize: "33px" }}
                                            />
                                          )}
                                        </div>
                                        <div>
                                          <p
                                            style={{
                                              fontSize: "19px",
                                              fontWeight: "600",
                                              margin: 0,
                                            }}
                                          >
                                            {item.count}
                                          </p>
                                          <p
                                            style={{
                                              margin: 0,
                                            }}
                                          >
                                            {item.status}
                                          </p>
                                        </div>
                                      </div>
                                      <div style={{ alignSelf: "end" }}>
                                        <p
                                          style={{
                                            margin: 0,
                                          }}
                                        >
                                          {item.percentage}
                                        </p>
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-md-6 ">
                    <div className=" mb-4">
                      <EnhancedTopAuthors data={topPerformers} />
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-6 h-100">
                    <div className="col-12 h-100">
                      <div
                        className="card card-layout shadow-sm"
                        style={{ height: "500px" }}
                      >
                        <div
                          className="card-header bg-transparent"
                          style={{ padding: "21px", paddingBottom: "4px" }}
                        >
                          <div className="d-flex flex-wrap align-items-start justify-content-between turnover">
                            <div
                              className="me-2 align-self-center"
                              style={{ height: "100%" }}
                            >
                              <h5 className="card-title fs-5 mb-0 ">
                                Success Rates
                              </h5>
                            </div>

                            <div>
                              <div className="d-flex gap-4 justify-content-center mt-3 mt-md-0">
                                {/* Merchant & Agent Toggle */}
                                <div className="d-flex align-items-center gap-2">
                                  <span
                                    className="text-muted"
                                    style={{ fontSize: "12px" }}
                                  >
                                    Merchant
                                  </span>
                                  <Switch
                                    checked={isAgent}
                                    onChange={() => setIsAgent(!isAgent)}
                                    color="primary"
                                  />
                                  <span
                                    className="text-muted"
                                    style={{ fontSize: "12px" }}
                                  >
                                    Agent
                                  </span>
                                </div>

                                {/* PayIn & Payout Toggle */}
                                <div className="d-flex align-items-center gap-2">
                                  <span
                                    className="text-muted"
                                    style={{ fontSize: "12px" }}
                                  >
                                    PayIn
                                  </span>
                                  <Switch
                                    checked={isPayout}
                                    onChange={() => setIsPayout(!isPayout)}
                                    color="primary"
                                  />
                                  <span
                                    className="text-muted"
                                    style={{ fontSize: "12px" }}
                                  >
                                    Payout
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="d-flex justify-content-end me-3">
                          <ul
                            className="nav nav-tabs nav-tabs-turnover nav-tabs-custom card-header-tabs "
                            role="tablist"
                            style={{
                              borderBottom: "0px solid var(--bs-border-color)",
                            }}
                          >
                            <li
                              className="nav-item"
                              role="presentation"
                              onClick={() => durationForSR(1)}
                            >
                              <a
                                className="nav-link active px-2"
                                style={{
                                  fontSize: "12px",
                                }}
                                data-bs-toggle="tab"
                                href="#post-recent"
                                role="tab"
                                aria-selected="true"
                              >
                                {" "}
                                1Hr{" "}
                              </a>
                            </li>
                            <li
                              className="nav-item"
                              role="presentation"
                              onClick={() => durationForSR(2)}
                            >
                              <a
                                className="nav-link px-2"
                                style={{
                                  fontSize: "12px",
                                }}
                                data-bs-toggle="tab"
                                href="#post-recents"
                                role="tab"
                                aria-selected="false"
                                tabIndex={-1}
                              >
                                2Hr{" "}
                              </a>
                            </li>
                            <li
                              className="nav-item"
                              role="presentation"
                              onClick={() => durationForSR(4)}
                            >
                              <a
                                className="nav-link px-2"
                                style={{
                                  fontSize: "12px",
                                }}
                                data-bs-toggle="tab"
                                href="#post-popular"
                                role="tab"
                                aria-selected="false"
                                tabIndex={-1}
                              >
                                {" "}
                                4Hr{" "}
                              </a>
                            </li>
                            <li
                              className="nav-item"
                              role="presentation"
                              onClick={() => durationForSR(24)}
                            >
                              <a
                                className="nav-link px-2"
                                style={{
                                  fontSize: "12px",
                                }}
                                data-bs-toggle="tab"
                                href="#post-populars"
                                role="tab"
                                aria-selected="false"
                                tabIndex={-1}
                              >
                                {" "}
                                Day{" "}
                              </a>
                            </li>
                          </ul>
                        </div>

                        <div className="card-body py-0 ">
                          <div
                            style={{
                              padding: "0px",
                              backgroundColor: "#ffffff",
                              borderRadius: "10px",
                            }}
                          >
                            {/* {successDetails &&( */}
                            <SuccessRate
                              successDetails={successDetails}
                              srDuration={srDuration}
                              isAgent={isAgent}
                              isPayout={isPayout}
                            />
                            {/* )} */}

                            {/* <MultiSeriesBarChart
                              data={ticketing}
                              duration={ticketingDuration}
                            /> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* end row */}
                <div className="row">
                  <div className="col-xl-6 ">
                    <div className="col-12">
                      <div className="card card-layout shadow-sm">
                        <div
                          className="card-header bg-transparent"
                          style={{ padding: "21px" }}
                        >
                          <div className="d-flex flex-wrap align-items-start turnover">
                            <div
                              className="me-2 align-self-center"
                              style={{ height: "100%" }}
                            >
                              <h5 className="card-title fs-5 mt-1 mb-0 ">
                                Ticketing
                              </h5>
                            </div>
                            <ul
                              className="nav nav-tabs nav-tabs-turnover nav-tabs-custom card-header-tabs ms-auto"
                              role="tablist"
                              style={{
                                borderBottom:
                                  "0px solid var(--bs-border-color)",
                              }}
                            >
                              <li
                                className="nav-item"
                                role="presentation"
                                onClick={() => durationForTicketing("Today")}
                              >
                                <a
                                  className="nav-link active px-2"
                                  style={{
                                    fontSize: "12px",
                                  }}
                                  data-bs-toggle="tab"
                                  href="#post-recent"
                                  role="tab"
                                  aria-selected="true"
                                >
                                  {" "}
                                  Today{" "}
                                </a>
                              </li>
                              <li
                                className="nav-item"
                                role="presentation"
                                onClick={() =>
                                  durationForTicketing("Yesterday")
                                }
                              >
                                <a
                                  className="nav-link px-2"
                                  style={{
                                    fontSize: "12px",
                                  }}
                                  data-bs-toggle="tab"
                                  href="#post-recents"
                                  role="tab"
                                  aria-selected="false"
                                  tabIndex={-1}
                                >
                                  Yesterday{" "}
                                </a>
                              </li>
                              <li
                                className="nav-item"
                                role="presentation"
                                onClick={() => durationForTicketing("Weekly")}
                              >
                                <a
                                  className="nav-link px-2"
                                  style={{
                                    fontSize: "12px",
                                  }}
                                  data-bs-toggle="tab"
                                  href="#post-popular"
                                  role="tab"
                                  aria-selected="false"
                                  tabIndex={-1}
                                >
                                  {" "}
                                  Weekly{" "}
                                </a>
                              </li>
                              <li
                                className="nav-item"
                                role="presentation"
                                onClick={() => durationForTicketing("Monthly")}
                              >
                                <a
                                  className="nav-link px-2"
                                  style={{
                                    fontSize: "12px",
                                  }}
                                  data-bs-toggle="tab"
                                  href="#post-populars"
                                  role="tab"
                                  aria-selected="false"
                                  tabIndex={-1}
                                >
                                  {" "}
                                  Monthly{" "}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div className="card-body">
                          <div
                            style={{
                              // padding: "31px 0px",
                              backgroundColor: "#ffffff",
                              borderRadius: "10px",
                            }}
                          >
                            <MultiSeriesBarChart
                              data={ticketing}
                              duration={ticketingDuration}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div>
                      <div className="card-header bg-transparent mt-0"></div>
                      <div
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "10px",
                        }}
                      >
                        <div>
                          <TopTransactionHistory topTicketing={topTickets} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* top lsit card 2 */}

                {/* Top 5 cards */}

                {/* column bar chart */}
                {/* 
                <div className="row">
                  <div className="col-xl-6">
                    <div className="card shadow-sm card-layout">
                      <div
                        className="card-header bg-transparent "
                        style={{ padding: "21px" }}
                      >
                        <div className="d-flex flex-wrap align-items-start">
                          <div
                            className="me-2 align-self-center"
                            style={{ height: "100%" }}
                          >
                            <h5 className="card-title fs-5 mt-1 mb-0 ">
                              Pay In
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        
                        <div
                          style={{
                            backgroundColor: "#ffffff",
                            borderRadius: "10px",
                          }}
                        >
                          <div>
                            <AreaChart />
                          </div>
                        </div>
                       
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-6 ">
                    <div className="col-12">
                      <div className="card card-layout shadow-sm">
                        <div
                          className="card-header bg-transparent"
                          style={{ padding: "21px" }}
                        >
                          <div className="d-flex flex-wrap align-items-start turnover">
                            <div
                              className="me-2 align-self-center"
                              style={{ height: "100%" }}
                            >
                              <h5 className="card-title fs-5 mt-1 mb-0 ">
                                Pay Out
                              </h5>
                            </div>
                            <ul
                              className="nav nav-tabs nav-tabs-turnover nav-tabs-custom card-header-tabs ms-auto"
                              role="tablist"
                              style={{
                                borderBottom:
                                  "0px solid var(--bs-border-color)",
                              }}
                            >
                              <li className="nav-item" role="presentation">
                                <a
                                  className="nav-link active px-2"
                                  style={{
                                    fontSize: "14px",
                                  }}
                                  data-bs-toggle="tab"
                                  href="#post-recent"
                                  role="tab"
                                  aria-selected="true"
                                >
                                  {" "}
                                  Today{" "}
                                </a>
                              </li>
                              <li className="nav-item" role="presentation">
                                <a
                                  className="nav-link px-2"
                                  style={{
                                    fontSize: "14px",
                                  }}
                                  data-bs-toggle="tab"
                                  href="#post-recents"
                                  role="tab"
                                  aria-selected="false"
                                  tabIndex={-1}
                                >
                                  Yesterday{" "}
                                </a>
                              </li>
                              <li className="nav-item" role="presentation">
                                <a
                                  className="nav-link px-2"
                                  style={{
                                    fontSize: "14px",
                                  }}
                                  data-bs-toggle="tab"
                                  href="#post-popular"
                                  role="tab"
                                  aria-selected="false"
                                  tabIndex={-1}
                                >
                                  {" "}
                                  Weekly{" "}
                                </a>
                              </li>
                              <li className="nav-item" role="presentation">
                                <a
                                  className="nav-link px-2"
                                  style={{
                                    fontSize: "14px",
                                  }}
                                  data-bs-toggle="tab"
                                  href="#post-populars"
                                  role="tab"
                                  aria-selected="false"
                                  tabIndex={-1}
                                >
                                  {" "}
                                  Monthly{" "}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="card-body">
                          <div
                            style={{
                              // padding: "31px 0px",
                              backgroundColor: "#ffffff",
                              borderRadius: "10px",
                            }}
                          >
                           
                           
                            <PieChartExample />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
                {/* header primary color theme */}
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card dasboard-table shadow-sm table-Layout">
                      <div
                        className="card-body custom-scrollbar"
                        style={{
                          padding: "20px 25px",
                          height: "425px",
                          // backgroundColor: "#495A69",
                        }}
                      >
                        <h4
                          className="card-title mb-4 fs-5"
                          style={{ fontWeight: "600", color: "#343a40" }}
                        >
                          Latest Transactions
                        </h4>
                        <div
                          className="table-responsive"
                          style={{
                            height: "calc(100% - 40px)",
                            overflowY: "auto",
                          }}
                        >
                          <table className="table table-hover align-middle">
                            <thead
                              style={{
                                backgroundColor: "#495A69",
                                color: "white",
                              }}
                            >
                              <tr>
                                <th
                                  scope="col"
                                  style={{
                                    padding: "15px",
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 2,
                                    color: "#cbeceff5",
                                    backgroundColor: "#495A69",
                                  }}
                                >
                                  Order ID
                                </th>
                                <th
                                  scope="col"
                                  style={{
                                    padding: "12px",
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 2,
                                    color: "#cbeceff5",
                                    backgroundColor: "#495A69",
                                  }}
                                >
                                  Merchant
                                </th>
                                <th
                                  scope="col"
                                  style={{
                                    padding: "12px",
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 2,
                                    color: "#cbeceff5",
                                    backgroundColor: "#495A69",
                                  }}
                                >
                                  Agent
                                </th>
                                <th
                                  scope="col"
                                  style={{
                                    padding: "12px",
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 2,
                                    color: "#cbeceff5",
                                    backgroundColor: "#495A69",
                                  }}
                                >
                                  Type
                                </th>
                                <th
                                  scope="col"
                                  style={{
                                    padding: "12px",
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 2,
                                    color: "#cbeceff5",
                                    backgroundColor: "#495A69",
                                  }}
                                >
                                  Date
                                </th>
                                <th
                                  scope="col"
                                  style={{
                                    padding: "12px",
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 2,
                                    color: "#cbeceff5",
                                    backgroundColor: "#495A69",
                                  }}
                                >
                                  Total
                                </th>
                                <th
                                  scope="col"
                                  style={{
                                    padding: "12px",
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 2,
                                    color: "#cbeceff5",
                                    backgroundColor: "#495A69",
                                  }}
                                >
                                  Status
                                </th>
                                <th
                                  scope="col"
                                  style={{
                                    padding: "12px",
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 2,
                                    color: "#cbeceff5",
                                    backgroundColor: "#495A69",
                                  }}
                                >
                                  Method
                                </th>
                                <th
                                  scope="col"
                                  style={{
                                    padding: "12px",
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 2,
                                    color: "#cbeceff5",
                                    backgroundColor: "#495A69",
                                  }}
                                >
                                  View
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {transactionList
                                .slice(0, 8)
                                .map((transaction, index) => (
                                  <tr
                                    key={index}
                                    style={{
                                      backgroundColor:
                                        index % 2 === 0 ? "#f8f9fa" : "white",
                                    }}
                                  >
                                    <td style={{ padding: "12px" }}>
                                      <a
                                        href="#"
                                        className="textColorLightBlue fw-bold"
                                      >
                                        {transaction.order_code}{" "}
                                        <OpenInNewOutlinedIcon
                                          sx={{ fontSize: "16px" }}
                                        />
                                      </a>
                                    </td>
                                    <td style={{ padding: "12px" }}>
                                      <a
                                        href="#"
                                        className="textColorLightBlue fw-bold"
                                      >
                                        {transaction.sender_name}
                                      </a>
                                    </td>
                                    <td style={{ padding: "12px" }}>
                                      <a
                                        href="#"
                                        className="textColorLightBlue fw-bold"
                                      >
                                        {transaction.receiver_name}
                                      </a>
                                    </td>
                                    <td
                                      style={{
                                        padding: "12px",
                                        fontWeight: "600",
                                        color:
                                          transaction.transaction_type.toLowerCase() ===
                                          "payin"
                                            ? "#28a745"
                                            : "#dc3545",
                                      }}
                                    >
                                      <i
                                        className={`fa ${
                                          transaction.transaction_type.toLowerCase() ===
                                          "payin"
                                            ? "fa-arrow-down"
                                            : "fa-arrow-up"
                                        } me-1`}
                                      ></i>
                                      {transaction.transaction_type
                                        .charAt(0)
                                        .toUpperCase() +
                                        transaction.transaction_type
                                          .slice(1)
                                          .toLowerCase()}
                                    </td>
                                    <td
                                      style={{
                                        padding: "12px",
                                        fontWeight: "600",
                                      }}
                                      className="textColorLightBlue"
                                    >
                                      {moment(transaction.start_date).format(
                                        "DD-MM-YYYY"
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        padding: "12px",
                                        fontWeight: "600",
                                      }}
                                      className="textColorLightBlue"
                                    >
                                      ₹{transaction.amount}
                                    </td>
                                    <td style={{ padding: "12px" }}>
                                      <StatusBadge
                                        status={transaction.status}
                                      />
                                    </td>
                                    <td style={{ padding: "12px" }}>
                                      <i
                                        className={`fa me-1 textColorLightBlue ${
                                          transaction.payment_method?.toLowerCase() ===
                                          "imps"
                                            ? "fa-money"
                                            : transaction.payment_method?.toLowerCase() ===
                                              "wallet"
                                            ? "fa-credit-card"
                                            : transaction.payment_method?.toLowerCase() ===
                                              "upi"
                                            ? "fa-google-wallet"
                                            : transaction.payment_method?.toLowerCase() ===
                                              "qr"
                                            ? "fa-qrcode"
                                            : ""
                                        }`}
                                      ></i>
                                      {transaction.payment_method || "-"}
                                    </td>
                                    <td style={{ padding: "12px" }}>
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          viewTransaction(transaction)
                                        }
                                        className="text-decoration-none text-info textColorLightBlue "
                                      >
                                        <i
                                          className="fa fa-eye textColorLightBlue"
                                          style={{ fontSize: "16px" }}
                                        ></i>
                                      </a>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                          {transactionList.length === 0 && (
                            <div
                              className="text-center py-4"
                              style={{
                                color: "#6c757d",
                                fontWeight: "500",
                                backgroundColor: "#f8f9fa",
                                borderRadius: "5px",
                              }}
                            >
                              <b>No Transactions Found.</b>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-xl-6 ">
                    <div className="col-12">
                      <div className="card card-layout shadow-sm">
                        <div
                          style={{
                            // padding: "31px 0px",
                            backgroundColor: "#ffffff",
                            borderRadius: "10px",
                          }}
                        >
                          <div
                            className="card-header bg-transparent"
                            style={{ padding: "21px" }}
                          >
                            <div className="d-flex flex-wrap align-items-start turnover">
                              <div
                                className="me-2 align-self-center"
                                style={{ height: "100%" }}
                              >
                                <h5 className="card-title fs-5 mt-1 mb-0 ">
                                  TurnOver
                                </h5>
                              </div>
                              <ul
                                className="nav nav-tabs nav-tabs-turnover nav-tabs-custom card-header-tabs ms-auto"
                                role="tablist"
                                style={{
                                  borderBottom:
                                    "0px solid var(--bs-border-color)",
                                }}
                              >
                                <li className="nav-item" role="presentation">
                                  <a
                                    className="nav-link active px-2"
                                    style={{
                                      fontSize: "12px",
                                    }}
                                    data-bs-toggle="tab"
                                    href="#post-recent"
                                    role="tab"
                                    aria-selected="true"
                                  >
                                    {" "}
                                    Today{" "}
                                  </a>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <a
                                    className="nav-link px-2"
                                    style={{
                                      fontSize: "12px",
                                    }}
                                    data-bs-toggle="tab"
                                    href="#post-recents"
                                    role="tab"
                                    aria-selected="false"
                                    tabIndex={-1}
                                  >
                                    Yesterday{" "}
                                  </a>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <a
                                    className="nav-link px-2"
                                    style={{
                                      fontSize: "12px",
                                    }}
                                    data-bs-toggle="tab"
                                    href="#post-popular"
                                    role="tab"
                                    aria-selected="false"
                                    tabIndex={-1}
                                  >
                                    {" "}
                                    Weekly{" "}
                                  </a>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <a
                                    className="nav-link px-2"
                                    style={{
                                      fontSize: "12px",
                                    }}
                                    data-bs-toggle="tab"
                                    href="#post-populars"
                                    role="tab"
                                    aria-selected="false"
                                    tabIndex={-1}
                                  >
                                    {" "}
                                    Monthly{" "}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="shadow-sm">
                            <BarChart />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-6">
                    <div className="card shadow-sm card-layout">
                      <div
                        className="card-header bg-transparent "
                        style={{ padding: "21px" }}
                      >
                        <div className="d-flex flex-wrap align-items-start">
                          <div
                            className="me-2 align-self-center"
                            style={{ height: "100%" }}
                          >
                            <h5 className="card-title fs-5 mt-1 mb-0 ">
                              Payment Analytics
                            </h5>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div
                          style={{
                            backgroundColor: "#ffffff",
                            borderRadius: "10px",
                          }}
                        >
                          <div>
                            {radialChartDataSet && (
                              <RadialBarChart {...{ radialChartDataSet }} />
                            )}
                          </div>
                          <div className="d-flex align-items-center justify-content-around py-3">
                            <div
                              className="col-3 py-1 analytics-card-box-shadow"
                              style={{
                                backgroundColor: radialChartDataSet.colors[0],
                                borderRadius: "12px",
                                width: "20%",
                                color: "#495A69",
                              }}
                            >
                              <p
                                className="p-0 m-0 text-center fw-medium fs-5"
                                style={{ color: "#ffffff" }}
                              >
                                Wallet
                              </p>
                              <p
                                className="text-center p-0 m-0 text-white fs-5 fw-medium mt-1"
                                style={{ color: "#ffffff" }}
                              >
                                {transactionCount.wallet_count}
                              </p>
                            </div>
                            <div
                              className="col-3 py-1 analytics-card-box-shadow"
                              style={{
                                backgroundColor: radialChartDataSet.colors[1],
                                borderRadius: "12px",
                                width: "20%",
                                color: "#495A69",
                              }}
                            >
                              <p
                                className="p-0 m-0 text-center fw-medium fs-5"
                                style={{ color: "#ffffff" }}
                              >
                                UPI
                              </p>
                              <p className="text-center p-0 m-0 text-light fs-5 fw-medium mt-1">
                                {transactionCount.upi_count}
                              </p>
                            </div>
                            <div
                              className="col-3 py-1 analytics-card-box-shadow"
                              style={{
                                backgroundColor: radialChartDataSet.colors[2],
                                borderRadius: "12px",
                                width: "20%",
                                color: "#ffffff",
                              }}
                            >
                              <p className="p-0 m-0 text-center fw-medium fs-5 text-light">
                                QR Code
                              </p>
                              <p
                                className="text-center p-0 m-0 text-white fs-5 fw-medium mt-1"
                                style={{ color: "#ffffff" }}
                              >
                                {transactionCount.qr_count}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
function mapStateToProps(state) {
  const userData = state.authReducer.user;
  return { userData };
}
export default withAuth(connect(mapStateToProps)(AdminDashboard));
